import i18n from '@/i18n'
import { getAppName } from './env'
import { currencySymbol } from 'shared/helpers/currency'
import { provideSchool } from '@/helpers/school'

/**
 * Gets translation for current language.
 * It also replaces {currency} and {app_name} with proper for specific region values
 *
 * @param key Translation key
 * @returns Translation for given key
 */
export default function (key) {
    const school = provideSchool()
    if (!key || !school) return ''
    const currency_symbol = currencySymbol(school.currency)
    const appName = getAppName()
    const translation = i18n.t(key)
    return translation
        ? translation
              .toString()
              .replace('{currency}', currency_symbol)
              .replace('{app_name}', appName)
        : key
}
